




























































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import searchInput from "@/components/searchInput.vue";
import passwordModal from "@/views/usercenter/passwordModal.vue";
import util from "@/lib/util";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import _ from "lodash";
import Util from "@/lib/util";
import AppConsts from "@/lib/appconst";
import {paginationElement} from "@/api/typeDefined";

@Component({
  components: {
    searchInput,
  },
  filters: {
    imgUrlFilter(url: string = '') {
      if (url && url.indexOf('http') > -1) {
        return decodeURIComponent(url);
      } else {
        let fileResourceUrl: string = AppConsts.fileResourceUrl;
        return `${fileResourceUrl}${decodeURIComponent(url)}`;
      }
    }
  }
})
export default class myCollectKnow extends basicPage {
  customActiveKey = '0'
  hasHeight: boolean = false;
  data: any = {};
  resourcesPath: string = '';
  form: any;

  pagination: paginationElement = {
    ...AppConsts.pagination,
    onChange: pageIndex => {
      this.pagination.current = pageIndex;
      this.loadData();
    }
  };

  loadData() {
    let {current, pageSize} = this.pagination;
    const queryParams = {
      currentPage: current,
      pageSize: pageSize,
      collectType: 1,
    };

    ajaxHelperInstance.get('/web/user/collect', queryParams, undefined, this).then((res) => {
      let {status, data} = res;
      if (status === 200) {
        this.data = data.data || [];
        this.pagination.total = 0;

        console.table(data.data);
        if (data) {
          let {page} = data;
          if (page) {
            this.pagination.total = page.total;
          }
        }
      }
    });
  }

  handleShowDetail(docId) {
    let routerData = {
      docId: docId
    }
    this.$router.push({
      name: 'knowledgeBaseDetail',
      params: {
        'queryParams': JSON.stringify(routerData)
      }
    })
  }

  mounted() {
    this.loadData();
  }

}
